import React, { useState } from 'react';
import { LibraryItem } from './types';
import { gameEmbedUrl, safeGameUrl } from './gameMedia';
import './GameCardMedia.css';

export default function GameCardMedia({ title, game, previewUrl, startPlaying = false }: { title: string; game?: LibraryItem['game']; previewUrl?: string; startPlaying?: boolean }) {
  const [playing, setPlaying] = useState(startPlaying);
  const [failedPreview, setFailedPreview] = useState('');
  const url = safeGameUrl(game?.url);
  const embed = gameEmbedUrl(game?.embedUrl) || gameEmbedUrl(url);
  if (!url) return <div className="library-game-card library-game-card--empty"><span aria-hidden="true">🎮</span><p>Add a game link to preview and play.</p></div>;
  return <div className="library-game-card">
    {playing ? <iframe src={embed} title={`Play ${title}`} sandbox="allow-scripts allow-pointer-lock allow-forms" allow="fullscreen; gamepad" allowFullScreen />
      : <button type="button" className="library-game-launch" onClick={() => setPlaying(true)} aria-label={`Play ${title}`}>
        {previewUrl && failedPreview !== previewUrl ? <img src={previewUrl} alt={`${title} preview`} onError={() => setFailedPreview(previewUrl)} /> : <span className="library-game-launch__fallback"><span aria-hidden="true">🎮</span><strong>Ready to play</strong></span>}
        <span className="library-game-launch__label">Play game</span>
      </button>}
    <nav aria-label="Game controls">{playing && <button type="button" onClick={() => setPlaying(false)}>Stop playing</button>}<a href={url} target="_blank" rel="noopener noreferrer">Open game ↗</a></nav>
    {playing && <small>If the game doesn’t load here, choose Open game.</small>}
  </div>;
}
